<template>
  <v-container style="max-width: 1200px;">
<v-row>
  <v-col cols="12" md="4">

<v-card elevation="1" class="pa-4 mt-8" v-if="userData">
  <h3>
          <span style="color: #3166a5">
            3-fach Design-Aufsteller für WaizmannTabellen
          </span>
         <sup class="text-green">neu</sup>
        </h3>
<v-row >
  
      <v-col :cols="11" :md="9">
    
     
       Design-Aufsteller für Ihr <b>Wartezimmer</b>. Damit können Sie die WaizmannTabellen in Ihrer Praxis zur Mitnahme
       anbieten.
      </v-col>
      <v-col :cols="12" :md="3" v-if="baseStore.isDesktop">
        <img
          :src="require('@/assets/bestellung/dreifachaufsteller.jpg')"
          style="width: 100px; float: left"
        />
       
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12" :md="12">
        <v-btn color="primary" @click="startNeueBestellung">
    <v-icon>play_arrow</v-icon>
   hier klicken und kostenlos anfordern
  </v-btn>
      </v-col>
    </v-row>
    </v-card>
    <v-card elevation="1" class="pa-4 mt-8" v-if="!userData">
      <RegisterView newRoute="/waizmanntabellen_bestellen" class="mb-4" />
    </v-card>
  </v-col>
  <v-col cols="12" md="8">
    <component :is="currentComponent" class="my-4"/>
  </v-col>
 
</v-row>
  </v-container>
</template>

<script setup>
import { PRODUCT_KEYS } from '@/constants/bestellProdukte'
import { inject, onMounted, computed,defineAsyncComponent,reactive } from 'vue'
import RegisterView from '@/components/objects/user/RegisterView.vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
const loaderStore = inject('loaderStore');
const successStore = inject('successStore');
const errorStore = inject('errorStore');
const baseStore = inject('baseStore')
const route = useRoute();
const type = computed(() => route.params.type);
const updateDocumentHead = inject('updateDocumentHead');
const baseCalls = inject('baseCalls')
const userStore = inject('userStore');

const bestellung = reactive({
    bestell_status: 0,
    bestell_comment: "",
    bestell_produkt_text: PRODUCT_KEYS.STAND_TRIPLE,
    bestell_kategorie: 0,
    action: 'neueBestellung',

  });
const { userData } = storeToRefs(userStore)

const currentComponent = computed(() => {
  if (route.params.type) {
    return defineAsyncComponent(() => 
    import(`@/components/sites/objects/praxiswissen/${type.value}Index.vue`)
  );
  } else {
    return defineAsyncComponent(() => 
      import(`@/components/sites/objects/praxiswissen/PraxiswissenWall.vue`)
    );
  }
});


async function startNeueBestellung()
{
  loaderStore.setLoader(true)
  const response = await baseCalls.bestellungPost(bestellung)
  if (response.data.success) {
    loaderStore.setLoader(false)
    successStore.setSuccess(true,'Ihre Bestellung wurde erfolgreich gespeichert','Ihre Bestellung wird in Kürze bearbeitet.')
    bestellung.bestell_produkt_text = '';
    bestellung.bestell_comment = '';
  } else {
    loaderStore.setLoader(false)
    errorStore.setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
  }
}
async function startLogin() {
  const data = { action: 'startlogin',token: route.params.token }
  //console.log(data);
 
  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      userStore.setUser(response.data.user )

     
    } 
  } catch (err) {
   
    
    console.error('API-Fehler:', err);
  } 
}


onMounted(async () => {

  if(route.params.token != null){
    await startLogin();
  }

  const type = route.params.type;
  if(type == 'Prophylaxe'){
    updateDocumentHead(
      'TeamWaizmann | Praxiswissen Prophylaxe & Zahnzusatzversicherung',
      'TeamWaizmann | Praxiswissen Prophylaxe & Zahnzusatzversicherung'
    ) 
  }
  if(type == 'FehlendeZaehne'){
    updateDocumentHead(
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & fehlende Zähne',
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & fehlende Zähne'
    ) 
  }
  if(type == 'AngerateneBehandlung'){
    updateDocumentHead(
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & angeratene Behandlung',
      'TeamWaizmann | Praxiswissen Zahnzusatzversicherung & angeratene Behandlung'
    ) 
  }
 


})
</script>